import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function PourquoiAgir() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Pourquoi agir <strong className="text-brand-blue">vite</strong>
            </h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                  <i className="ri-home-smile-line text-brand-cyan text-base"></i>
                </div>
                <div>
                  <h3 className="text-brand-blue font-bold text-base mb-1">Volet bloqué ouvert</h3>
                  <p className="text-brand-text text-sm leading-relaxed">
                    Un volet bloqué en position ouverte expose votre logement : intrusion, intempéries, perte de chaleur. La sécurité de votre habitat est en jeu.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                  <i className="ri-sun-line text-brand-cyan text-base"></i>
                </div>
                <div>
                  <h3 className="text-brand-blue font-bold text-base mb-1">Volet bloqué fermé</h3>
                  <p className="text-brand-text text-sm leading-relaxed">
                    Un volet coincé en position fermée prive votre pièce de lumière naturelle, bloque l'aération et peut rendre une sortie de secours inaccessible.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                  <i className="ri-time-line text-brand-cyan text-base"></i>
                </div>
                <div>
                  <h3 className="text-brand-blue font-bold text-base mb-1">Remise en service rapide</h3>
                  <p className="text-brand-text text-sm leading-relaxed">
                    Plus vous attendez, plus la panne peut s'aggraver. Nous intervenons rapidement pour limiter les désagréments et éviter un remplacement complet.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder
              src="https://readdy.ai/api/search-image?query=Modern%20French%20apartment%20window%20with%20a%20white%20roller%20shutter%20stuck%20in%20a%20partially%20open%20position%2C%20letting%20in%20warm%20sunlight%2C%20creating%20a%20cozy%20interior%20atmosphere%20with%20wooden%20furniture%20and%20neutral%20decor%2C%20soft%20shadows%2C%20professional%20real%20estate%20photography%2C%20warm%20white%20and%20beige%20tones%2C%20inviting%20home%20environment&width=700&height=520&seq=pourquoi_depannage&orientation=landscape"
              alt="Volet roulant bloqué nécessitant une intervention rapide à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
              width={700}
              height={520}
            />
          </div>
        </div>
      </div>
    </section>
  );
}